import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";

import { Button, Dropdown, Menu, Row, Tooltip } from "antd";

import Swal from "sweetalert2";

import partnersApi from "../../apis/Partners.api";
import plutusApi from "../../apis/Plutus.api";
import {
	setChannelUser,
	setMenuList,
	setUser,
} from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";

const HeaderComponent = () => {
	const history = useHistory();
	const location = useLocation();
	const path = location.pathname;
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const menuList = useSelector((state) => state.auth.menuList);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const logout = async () => {
		setIsLoading(true);
		Swal.fire({
			customClass: "alert-custom",
			text: `정말 로그아웃 하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				const param = {
					id: user.id,
				};
				await partnersApi.logout(param);
				localStorage.removeItem("accessToken");
				localStorage.removeItem("refreshToken");
				localStorage.removeItem("admin:accessToken");
				localStorage.removeItem("admin:refreshToken");

				dispatch(setChannelUser(null));
				dispatch(setUser(null));
				// dispatch(setMenu([]))
				setIsLoading(false);
				history.push(`/`);
			}
		});
		setIsLoading(false);
	};

	const readMenuList = async () => {
		setIsLoading(true);
		try {
			const param = {
				user_id: user?.role !== "level_2" ? 1 : 10,
				system_id: 1,
			};
			const res = await plutusApi.getMenuList(param);
			if (res.code === 200) {
				let partners = res.result.filter(
					(item) => item?.menu_id === "partners"
				);
				let list = partners?.[0].subMenuList;
				// 메디슨맨님인 경우, 홈/상품 링크/사이트 관리/회원관리 메뉴 숨김처리 (2024.03.28) - ksb
				if (user?.id === 7) {
					list = list.filter(
						(menu) =>
							menu.menu_id !== "dashboard" &&
							menu.menu_id !== "products" &&
							menu.menu_id !== "edit/channel" &&
							menu.menu_id !== "user"
					);
				}
				dispatch(setMenuList(list));
			} else {
				throw res.msg;
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			alert(error);
		}
	};

	useLayoutEffect(() => {
		readMenuList();
	}, [user]);

	const menu = (
		<Menu>
			{user?.role === "super_admin" && (
				<Menu.Item>
					<Link
						to={`/dashboard`}
						style={
							path.includes("/dashboard")
								? {
										color: "#117ffa",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						홈
					</Link>
				</Menu.Item>
			)}
			{(user?.role === "super_admin" || user?.id !== 9) && (
				<Menu.Item>
					<Link
						to={`/products`}
						style={
							path === "/products"
								? {
										color: "#117ffa",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						상품 링크
					</Link>
				</Menu.Item>
			)}
			<Menu.Item>
				<Link
					to={`/edit/channel`}
					style={
						path === "/edit/channel"
							? {
									color: "#117ffa",
									fontWeight: "bold",
							  }
							: {}
					}
				>
					사이트 관리
				</Link>
			</Menu.Item>
			<Menu.Item>
				<Link
					to={`/user_comment_manage`}
					style={
						path === "/inquiry_manage" ||
						path === "/group_buying" ||
						path === "/user_message" ||
						path === "/user_app_push" ||
						path === "/user_comment_manage" ||
						path === "/user_mission_comment_manage" ||
						path === "/user_manage"
							? {
									color: "#117ffa",
									fontWeight: "bold",
							  }
							: {}
					}
				>
					회원관리
				</Link>
			</Menu.Item>
			{(user?.role === "level_1" || user?.role === "super_admin") && (
				<Menu.Item>
					<Link
						to={`/reports_analysis/category`}
						style={
							path === "/reports" || path.includes("/analysis")
								? {
										color: "#117ffa",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						{/*판매・정산*/}
						리포트
					</Link>
				</Menu.Item>
			)}
			{/*<Menu.Item>*/}
			{/*    <Link to={`/edit/board`} style={path === "/edit/board" ? {*/}
			{/*        color: "#117ffa",*/}
			{/*        fontWeight: "bold"*/}
			{/*    } : {}}>*/}
			{/*        게시판 관리*/}
			{/*    </Link>*/}
			{/*</Menu.Item>*/}
			{(user?.role === "level_1" || user?.role === "super_admin") && (
				<Menu.Item>
					<Link
						to={`/faq`}
						style={
							path === "/faq"
								? {
										color: "#117ffa",
										fontWeight: "bold",
								  }
								: {}
						}
					>
						자주묻는 질문
					</Link>
				</Menu.Item>
			)}
			{/*<Menu.Item>*/}
			{/*    <Link to={`/notice`} style={path.includes("/notice") ? {*/}
			{/*        color: "#117ffa",*/}
			{/*        fontWeight: "bold"*/}
			{/*    } : {}}>*/}
			{/*        공지사항*/}
			{/*    </Link>*/}
			{/*</Menu.Item>*/}
		</Menu>
	);

	const items = menuList?.length
		? menuList?.map((item) => {
				// let normalUser = item?.menu_visible?.includes("level_2");
				let adminUser = user?.role && item?.menu_visible?.includes(user?.role);
				if (adminUser) {
					return {
						label: (
							<Link
								to={item.link_url}
								style={
									path.includes(item.menu_id)
										? {
												color: "#117ffa",
												fontWeight: "bold",
										  }
										: {}
								}
							>
								{item.menu_name}
							</Link>
						),
						key: item.id,
					};
				}
		  })
		: [];

	const itemsGuest = [
		{
			label: (
				<Link
					to={"/faq"}
					style={
						path.includes("/faq")
							? {
									color: "#117ffa",
									fontWeight: "bold",
							  }
							: {}
					}
				>
					자주묻는 질문
				</Link>
			),
			key: 1,
		},
		{
			label: (
				<Link
					to={"/notice"}
					style={
						path.includes("/notice")
							? {
									color: "#117ffa",
									fontWeight: "bold",
							  }
							: {}
					}
				>
					공지사항
				</Link>
			),
			key: 2,
		},
		{
			label: (
				<Link
					to={"/benefit/information"}
					style={
						path.includes("/benefit/information")
							? {
									color: "#117ffa",
									fontWeight: "bold",
							  }
							: {}
					}
				>
					이용가이드
				</Link>
			),
			key: 3,
		},
	];

	return (
		<Row
			justify="space-between"
			align="middle"
			wrap={false}
			className="together-header-wrap noselect"
		>
			{user ? (
				<div className={`header-link-div`}>
					{/* 모바일 햄버그 드롭다운 */}
					<Dropdown
						menu={{ items }}
						placement="bottomLeft"
						arrow={true}
						trigger={["click"]}
						className={`menu-dropdown`}
					>
						<img
							src={`/assets/images/hamburger-icon.png`}
							alt={`햄버그 아이콘`}
							style={{
								width: "1.5em",
								height: "auto",
								cursor: "pointer",
							}}
						/>
					</Dropdown>
					{/* 로고 */}
					<Link to={`/`}>
						<img
							src={`/assets/images/main/togetherLogo.png`}
							className="together-header-logo"
							alt={`당영 투게더 로고`}
						/>
					</Link>
					{menuList?.length ? (
						<div className={`link-group`}>
							{menuList?.map((item) => {
								let adminUser =
									user?.role && item?.menu_visible?.includes(user?.role);
								if (adminUser) {
									return (
										<Link
											key={`menu-${item.menu_id}`}
											to={item.link_url}
											style={
												path.includes(item.menu_id)
													? {
															color: "#117ffa",
															fontWeight: "bold",
													  }
													: {}
											}
										>
											{item.menu_name}
										</Link>
									);
								}
							})}
						</div>
					) : (
						<div className={`link-group`}></div>
					)}
					{/*<Link*/}
					{/*	to={`/dashboard`}*/}
					{/*	style={*/}
					{/*		path.includes("/dashboard")*/}
					{/*			? {*/}
					{/*					color: "#117ffa",*/}
					{/*					fontWeight: "bold",*/}
					{/*			  }*/}
					{/*			: {}*/}
					{/*	}*/}
					{/*>*/}
					{/*	홈*/}
					{/*</Link>*/}

					{/*{(user?.role === "super_admin" || user?.id !== 9) && (*/}
					{/*	<Link*/}
					{/*		to={`/products`}*/}
					{/*		style={*/}
					{/*			path === "/products"*/}
					{/*				? {*/}
					{/*						color: "#117ffa",*/}
					{/*						fontWeight: "bold",*/}
					{/*				  }*/}
					{/*				: {}*/}
					{/*		}*/}
					{/*	>*/}
					{/*		상품 링크*/}
					{/*	</Link>*/}
					{/*)}*/}

					{/*<Link*/}
					{/*	to={`/edit/channel`}*/}
					{/*	style={*/}
					{/*		path === "/edit/channel"*/}
					{/*			? {*/}
					{/*					color: "#117ffa",*/}
					{/*					fontWeight: "bold",*/}
					{/*			  }*/}
					{/*			: {}*/}
					{/*	}*/}
					{/*>*/}
					{/*	사이트 관리*/}
					{/*</Link>*/}
					{/*<Link*/}
					{/*	to={`/user_comment_manage`}*/}
					{/*	style={*/}
					{/*		path === "/inquiry_manage" ||*/}
					{/*		path === "/group_buying" ||*/}
					{/*		path === "/user_message" ||*/}
					{/*		path === "/user_app_push" ||*/}
					{/*		path === "/user_comment_manage" ||*/}
					{/*		path === "/user_mission_comment_manage" ||*/}
					{/*		path === "/user_manage"*/}
					{/*			? {*/}
					{/*					color: "#117ffa",*/}
					{/*					fontWeight: "bold",*/}
					{/*			  }*/}
					{/*			: {}*/}
					{/*	}*/}
					{/*>*/}
					{/*	회원관리*/}
					{/*</Link>*/}

					{/*{(user?.role === "level_1" || user?.role === "super_admin") && (*/}
					{/*	<Link*/}
					{/*		to={`/reports_analysis/category`}*/}
					{/*		style={*/}
					{/*			path === "/reports" || path.includes("/analysis")*/}
					{/*				? {*/}
					{/*						color: "#117ffa",*/}
					{/*						fontWeight: "bold",*/}
					{/*				  }*/}
					{/*				: {}*/}
					{/*		}*/}
					{/*	>*/}
					{/*		/!*판매・정산*!/*/}
					{/*		리포트*/}
					{/*	</Link>*/}
					{/*)}*/}
					{/*/!*<Link to={`/edit/board`} style={path === "/edit/board" ? {*!/*/}
					{/*/!*    color: "#117ffa",*!/*/}
					{/*/!*    fontWeight: "bold"*!/*/}
					{/*/!*} : {}}>*!/*/}
					{/*/!*    게시판 관리*!/*/}
					{/*/!*</Link>*!/*/}

					{/*{(user?.role === "level_1" || user?.role === "super_admin") && (*/}
					{/*	<Link*/}
					{/*		to={`/faq`}*/}
					{/*		style={*/}
					{/*			path === "/faq"*/}
					{/*				? {*/}
					{/*						color: "#117ffa",*/}
					{/*						fontWeight: "bold",*/}
					{/*				  }*/}
					{/*				: {}*/}
					{/*		}*/}
					{/*	>*/}
					{/*		자주묻는 질문*/}
					{/*	</Link>*/}
					{/*)}*/}
					{/*<Link to={`/notice`} style={path.includes("/notice") ? {*/}
					{/*    color: "#117ffa",*/}
					{/*    fontWeight: "bold"*/}
					{/*} : {}}>*/}
					{/*    공지사항*/}
					{/*</Link>*/}
					{/*</div>*/}
				</div>
			) : (
				// 비회원
				<div className={`header-link-div`}>
					<Dropdown
						menu={{ items: itemsGuest }}
						placement="bottomLeft"
						arrow={true}
						trigger={["click"]}
						className={`menu-dropdown`}
					>
						<img
							src={`/assets/images/hamburger-icon.png`}
							alt={`햄버그 아이콘`}
							style={{
								width: "1.5em",
								height: "auto",
								cursor: "pointer",
							}}
						/>
					</Dropdown>
					<Link to={`/`}>
						<img
							src={`/assets/images/main/togetherLogo.png`}
							className="together-header-logo"
							alt={`당영 투게더 로고`}
						/>
					</Link>
					<div className={`link-group`}>
						<Link
							to={`/faq`}
							style={
								path === "/faq"
									? {
											color: "#117ffa",
											fontWeight: "bold",
									  }
									: {}
							}
						>
							자주묻는 질문
						</Link>
						<Link
							to={`/notice`}
							style={
								path === "/notice"
									? {
											color: "#117ffa",
											fontWeight: "bold",
									  }
									: {}
							}
						>
							공지사항
						</Link>
						<Link
							to={`/benefit/information`}
							style={
								path === "/benefit/information"
									? {
											color: "#117ffa",
											fontWeight: "bold",
									  }
									: {}
							}
						>
							이용가이드
						</Link>
					</div>
				</div>
			)}
			{user ? (
				<div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
					<UserGradeIconNickname user={user} />
					{/*<div*/}
					{/*	style={{*/}
					{/*		display: "flex",*/}
					{/*		gap: "0.5em",*/}
					{/*		alignItems: "center",*/}
					{/*		height: "5em",*/}
					{/*	}}*/}
					{/*>*/}
					{/*	<button*/}
					{/*		style={{*/}
					{/*			display: "flex",*/}
					{/*			height: "100%",*/}
					{/*			alignItems: "center",*/}
					{/*		}}*/}
					{/*		onClick={logout}*/}
					{/*		disabled={isLoading}*/}
					{/*	>*/}
					{/*		로그아웃*/}
					{/*	</button>*/}
					{/*</div>*/}
					{/*<Tooltip*/}
					{/*	// className={`header-user-div-mobile`}*/}
					{/*	arrow={true}*/}
					{/*	trigger={"click"}*/}
					{/*	placement="bottomRight"*/}
					{/*	overlayStyle={{*/}
					{/*		position: "fixed",*/}
					{/*	}}*/}
					{/*	title={() => (*/}
					{/*		<div*/}
					{/*			style={{*/}
					{/*				display: "flex",*/}
					{/*				flexDirection: "column",*/}
					{/*				alignItems: "center",*/}
					{/*				gap: 3,*/}
					{/*			}}*/}
					{/*		>*/}
					{/*			<span style={{ color: "white" }}>{user?.nickname}</span>*/}
					{/*			<span style={{ color: "white" }}>{user?.user_id}</span>*/}
					{/*			<Button*/}
					{/*				size={`small`}*/}
					{/*				onClick={logout}*/}
					{/*				style={{ fontSize: "1em", marginTop: 5 }}*/}
					{/*			>*/}
					{/*				로그아웃*/}
					{/*			</Button>*/}
					{/*		</div>*/}
					{/*	)}*/}
					{/*>*/}
					{/*<button*/}
					{/*	onClick={() => history.push(`/user/mygrade`)}*/}
					{/*	style={{ display: "flex" }}*/}
					{/*>*/}
					{/*	<img*/}
					{/*		src={`/assets/images/user-icon.png`}*/}
					{/*		alt={`유저 이미지`}*/}
					{/*		style={{*/}
					{/*			width: "auto",*/}
					{/*			height: "1.6em",*/}
					{/*			cursor: "pointer",*/}
					{/*		}}*/}
					{/*	/>*/}
					{/*</button>*/}
					{/*</Tooltip>*/}
				</div>
			) : (
				// <div className="together-header-user-wrap">
				//     ID: {user.user_id}
				//     <span className="together-header-logout" onClick={logout}>로그아웃</span>
				// </div>
				// <img src={`${process.env.REACT_APP_HOST}/assets/images/landing/landing-beta-icon.jpg`}
				//      className="together-header-beta-icon"
				//      alt={`당영 투게더 아이콘`}
				// />
				<div
					style={{
						display: "flex",
						alignItems: "center",
						height: "5em",
					}}
				>
					<button
						style={{
							display: "flex",
							height: "100%",
							alignItems: "center",
						}}
						onClick={() => history.push(`/login`)}
					>
						로그인
					</button>
					<button
						style={{
							display: "flex",
							height: "100%",
							alignItems: "center",
						}}
						onClick={() => history.push(`/login`)}
					>
						회원가입
					</button>
				</div>
			)}
		</Row>
	);
};

const UserGradeIconNickname = ({ user }) => {
	const history = useHistory();
	const gradeIcon =
		user?.grade === "grade_3"
			? "seller_3"
			: user?.grade === "grade_2"
			? "seller_2"
			: "seller_1";
	return (
		<div className={`user-grade-icon-nickname`}>
			<button
				onClick={() => history.push(`/user/mygrade`)}
				style={{ display: "flex", alignItems: "center" }}
				// style={{ display: "flex", alignItems: "center", gap: 5 }}
			>
				<div
					style={{
						width: "1.8em",
						height: "1.8em",
						marginRight: "0.375rem",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						overflow: "hidden",
					}}
				>
					<img
						src={`/assets/images/seller/${gradeIcon}.png`}
						alt={`유저 아이콘`}
						style={{
							width: "80%",
							height: "80%",
							objectFit: "cover",
						}}
					/>
				</div>
				<p style={{ color: "#000", fontWeight: "500" }}>{user?.nickname}</p>
				<div
					style={{
						width: "0.8rem",
						height: "0.6rem",
						marginLeft: "0.5rem",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						overflow: "hidden",
					}}
				>
					<img
						src={`/assets/images/triangle-btn-icon.png`}
						alt={`삼각형 버튼`}
						style={{
							width: "100%",
							height: "100%",
							objectFit: "cover",
						}}
					/>
				</div>
			</button>
		</div>
	);
};

export default HeaderComponent;
